import { Component, OnInit, EventEmitter, Output, HostListener, ViewChild, OnChanges, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { WishlistService } from '../../wishlist.service';
import { ConnectCounsellorComponent } from '../../connect-counsellor/connect-counsellor.component';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'projects/foreign-admits/src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnChanges {

  @Input() partnerLogo!: string;
  // @Input() wishlistLength!: number;
  @Input() puid!: string;
  @Input() initialFilter: any;
  private baseUrl: string = environment.apiBaseUrl;
  @ViewChild('connectCounsellor') connectCounsellor!: ConnectCounsellorComponent;

  wishlistLength: number = 0;
  private wishlistCount = new BehaviorSubject<number>(0);
  wishlistCount$ = this.wishlistCount.asObservable();

  constructor(private router: Router, private wishlistService: WishlistService, private activatedRoute: ActivatedRoute, private http: HttpClient, private apiHelperService: ApiHelperService) { }


  ngOnInit(): void {
    console.log('Navbar Initialized with Wishlist Length:', this.wishlistLength);
    console.log('PUID in Navbar:', this.puid);

    this.wishlistService.getWishlist().subscribe((wishlistData) => {
      this.wishlistLength = wishlistData.wishlistLength;
      console.log('Updated Navbar Wishlist Count:', this.wishlistLength);
    });
  
   
    this.wishlistService.wishlistCount$.subscribe(count => {
      this.wishlistLength = count;
      console.log('Navbar wishlist updated:', this.wishlistLength);
    });
  }
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['wishlistLength']) {
      console.log('Navbar Wishlist Length Updated:', changes['wishlistLength'].currentValue);
    }
  }

  openConnectModal(): void {
    this.connectCounsellor.openModal();
  }

  viewWishlist(): void {
    if (this.puid) {
      this.router.navigate(['/wishlist', this.puid]);
    } else {
      this.router.navigate(['/wishlist']);
    }
  }

  viewProfile() {
  const puid = this.activatedRoute.snapshot.paramMap.get('puid');
  this.getStudentApplicantStatus().then((isApplicant: boolean) => {
    console.info(isApplicant, 71)
    if (isApplicant) {
      puid ? this.router.navigate(['/student-dashboard', puid])
           : this.router.navigate(['/student-dashboard']);
    } else {
      puid ? this.router.navigate(['/personal-details', puid])
           : this.router.navigate(['/personal-details']);
    }
  });
}


  private getStudentApplicantStatus(): Promise<boolean> {
    const uid = localStorage.getItem('uid');
    const token = localStorage.getItem('token');

    if (!uid || !token) {
      console.error('Missing UID or token');
      return Promise.resolve(false); 
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.apiHelperService.getDataWithShortlistingUrl(`student-choices/student-applicant-status/${uid}`).then(
      (res: any) => {
        if (typeof res === 'boolean') return res;
        if (res?.data?.status !== undefined) return !!res.data.status;
        if (res?.status !== undefined) return !!res.status;
        return false;
      }
    ).catch(err => {
      console.error('Error checking student applicant status:', err);
      return false;
    });
  }

  onRequestSubmitted(): void {
    console.log('Counsellor request submitted successfully!');
  }
}
